import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import ApplicationsTable from "../HRAdmincontent/ApplicationsTable";
import { ApplicationsUnderReview } from "../HRAdmincontent/UnderReview";
import EditInternshipPolicy from "../HRAdmincontent/EditInternshipPolicy";
import InternshipReport from "../HRAdmincontent/InternshipReports";
import ExtendInternship from "../HRAdmincontent/ExtendInternship";
import SuperAdminConsole from "./superAdmin";
import {
  AiOutlineFolder,
  AiOutlineEye,
  AiOutlineFileText,
  AiOutlineEdit,
  AiOutlineCalendar,
} from "react-icons/ai";
import { HiArchiveBoxArrowDown, HiDocumentCheck } from "react-icons/hi2";
import { FaListCheck } from "react-icons/fa6";
import { MdAdminPanelSettings, MdOutlinePendingActions } from "react-icons/md";
import { useUser } from "../context/UserContext";
import SignedLetters from "../HRAdmincontent/SignedLetters";

const InternShipManagementPage = () => {
  const { user } = useUser();
  const [activeNav, setActiveNav] = useState("All Applications");
  const [stats, setStats] = useState({
    pendingCount: 0,
    underReviewCount: 0,
  });
  const [isNavOpen, setIsNavOpen] = useState(false); // For hamburger menu
  const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:5000";
  //TODO:Comment during production build
  // const apiUrl = "http://localhost:5000/";

  const handleNavClick = (nav) => {
    setActiveNav(nav);
    setIsNavOpen(false); // Close the nav after selection
  };

  useEffect(() => {
    const fetchInternshipStats = async () => {
      try {
        const response = await fetch(`${apiUrl}api/applications-stats`);

        if (!response.ok) {
          throw new Error("Failed to fetch stats");
        }

        const data = await response.json();
        setStats({
          underReviewCount: data.underReviewApplications || 0,
          pendingCount: data.pendingApplications || 0,
        });
      } catch (error) {
        console.error("Error fetching internship stats:", error);
      }
    };

    fetchInternshipStats();
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      {/* Header */}
      <div className="sticky top-0 z-50 bg-white shadow-md">
        <Header />
      </div>

      {/* Page Title */}
      <div className="sticky top-[4rem] z-40 bg-gray-100 pt-4 pb-1">
        <h1 className="text-xl lg:text-2xl font-bold text-gray-600 text-center">
          Human Resource Administration Interface - Internship Applications
        </h1>
      </div>

      {/* Main content */}
      <div className="flex-1 bg-gray-100 overflow-hidden">
        <div className="flex flex-col lg:flex-row max-w-full px-3 lg:px-10 mx-auto py-3 w-full gap-5">
          {/* Mobile Hamburger */}
          <div className="lg:hidden px-4 pt-2">
            <button
              className="text-green-700 bg-white shadow-md p-2 rounded-md"
              onClick={() => setIsNavOpen(!isNavOpen)}
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d={
                    isNavOpen
                      ? "M6 18L18 6M6 6l12 12"
                      : "M4 6h16M4 12h16m-7 6h7"
                  }
                />
              </svg>
            </button>
          </div>

          {/* Sidebar Navigation */}
          <nav
            className={`bg-white shadow-md p-6 rounded-md lg:block lg:w-1/6 lg:top-0 sticky top-[8rem] h-[calc(100vh-11.8rem)] overflow-y-auto ${
              isNavOpen ? "block" : "hidden"
            } lg:relative lg:flex lg:flex-col`}
          >
            <ul className="space-y-4 font-semibold">
              <NavItem
                icon={<AiOutlineFolder size={23} />}
                label="All Applications"
                activeNav={activeNav}
                onClick={() => handleNavClick("All Applications")}
              />
              <NavItem
                icon={<AiOutlineEye size={23} />}
                label="Applications Under Review"
                statusCount={stats.underReviewCount}
                activeNav={activeNav}
                onClick={() => handleNavClick("Applications Under Review")}
              />
              <NavItem
                icon={<MdOutlinePendingActions size={25} />}
                label="Pending Applications"
                statusCount={stats.pendingCount}
                activeNav={activeNav}
                onClick={() => handleNavClick("Pending Applications")}
              />
              <NavItem
                icon={<FaListCheck size={22} />}
                label="Approved Applications"
                activeNav={activeNav}
                onClick={() => handleNavClick("Approved Applications")}
              />
              <NavItem
                icon={<HiArchiveBoxArrowDown size={23} />}
                label="Archived Applications"
                activeNav={activeNav}
                onClick={() => handleNavClick("Archived Applications")}
              />
              
              <NavItem
                icon={<AiOutlineCalendar size={23} />}
                label="Extend Internship Period"
                activeNav={activeNav}
                onClick={() => handleNavClick("Extend Internship Period")}
              />
              <NavItem
                icon={<HiDocumentCheck size={23} />}
                label="Signed Letters"
                activeNav={activeNav}
                onClick={() => handleNavClick("Signed Letters")}
              />
              <NavItem
                icon={<AiOutlineFileText size={23} />}
                label="Internship Reports"
                activeNav={activeNav}
                onClick={() => handleNavClick("Internship Reports")}
              />
              <NavItem
                icon={<AiOutlineEdit size={23} />}
                label="Edit Internship Policy Content"
                activeNav={activeNav}
                onClick={() => handleNavClick("Edit Internship Policy Content")}
              />
              {(user && user.username === "superadmin1") ||
                ("eddyodhiambo" && (
                  <NavItem
                    icon={<MdAdminPanelSettings size={30} />}
                    label="Super Admin Console"
                    activeNav={activeNav}
                    onClick={() => handleNavClick("Super Admin Console")}
                  />
                ))}
            </ul>
          </nav>

          {/* Content Area */}
          <div className="w-full lg:w-5/6 bg-white shadow-lg p-2 lg:p-6 rounded-md h-[calc(100vh-11.8rem)] overflow-x-auto lg:overflow-hidden">
            <div className="content">
              {activeNav === "All Applications" && (
                <ApplicationsTable activeNav={activeNav} />
              )}
              {activeNav === "Applications Under Review" && (
                <ApplicationsUnderReview />
              )}
              {activeNav === "Pending Applications" && (
                <ApplicationsTable activeNav={activeNav} />
              )}
              {activeNav === "Approved Applications" && (
                <ApplicationsTable activeNav={activeNav} />
              )}
              {activeNav === "Archived Applications" && (
                <ApplicationsTable activeNav={activeNav} />
              )}
              
              {activeNav === "Signed Letters" && (
                <SignedLetters activeNav={activeNav} />
              )}
              {activeNav === "Extend Internship Period" && <ExtendInternship />}
              {activeNav === "Internship Reports" && <InternshipReport />}
              {activeNav === "Edit Internship Policy Content" && (
                <EditInternshipPolicy />
              )}
              {activeNav === "Super Admin Console" && <SuperAdminConsole />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Navigation Item Component
const NavItem = ({ icon, label, statusCount, activeNav, onClick }) => {
  return (
    <li
      onClick={onClick}
      className={`cursor-pointer p-3 rounded-md text-gray-600 hover:bg-gray-300 transition duration-200 flex justify-between items-center ${
        activeNav === label ? "bg-green-700 text-white" : ""
      }`}
    >
      <div className="flex items-center">
        {icon && (
          <span
            className={`mr-3 text-green-700 ${
              activeNav === label ? "text-white" : ""
            }`}
          >
            {icon}
          </span>
        )}
        <span>{label}</span>
      </div>

      {statusCount !== undefined && (
        <span className="ml-2 bg-yellow-300 text-gray-700 rounded-full px-[9px] py-1 text-xs font-bold">
          {statusCount}
        </span>
      )}
    </li>
  );
};

export default InternShipManagementPage;
